// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1mWdK","productName":"Table_productName__2LZVR"};